module.exports = __webpack_public_path__ + "img/Angel.6503f65b.jpg";